import React from 'react'
import ReactDOM from 'react-dom'
import Results from '../results/Main';
import { translator } from '../shared/I18n';

document.addEventListener('DOMContentLoaded', async () => {
  const translations = await import('../i18n/results_translations.json');
  translator.setTranslations(translations);

  const resultsElement = document.getElementById('results-react-container');
  if (resultsElement) {
    const props = { data: resultsElement.dataset };
    ReactDOM.render(React.createElement(Results, props), resultsElement);
  }
});
